const en = {
	home: "Home",
	services: "Services",
	pricing: "Pricing",
	resources: "Resources",
	contactUs: "Contact Us",
	callSales: "Call Sales",
	login: "Login",
	getStarted: "Get Started",
	blogs: "Blogs",
	aboutUs: "About us",
	partners: "Partners",
	tutorials: "Tutorials",
	faqs: "FAQs",
	ourTeam: "Our Team",
	ourVideos: "Our Videos",
	ourGallery: "Our Gallery",
	signUpForEmailUpdates: "Sign up for email updates",
	subscribeToOurNewsletterTheAccounter:
		"Subscribe to our newsletter The Accounter",
	enterYourEmail: "Enter your email",
	submit: "Submit",
	completeBookkeeping: "Complete Bookkeeping",
	trackExpenses: "Track Expenses",
	customInvoicing: "Custom Invoicing",
	vatServices: "VAT Services",
	insightsAndReports: "Insights and reports",
	blog: "Blog",
	careers: "Careers",
	other: "Other",
	privacyPolicy: "Privacy Policy",
	termsOfUse: "Terms of use",
	copyright: "Copyright © 2026 The Accounter - All Rights Reserved.",
	trustedByUaeBusinesses: "Trusted by 1,000+ UAE Businesses",
	stopWorryingAboutAccountingWeHandleEverything:
		"Stop Worrying About Accounting. We Handle Everything.",
	heroDescription:
		"Upload your invoices. Our easy-to-use software + certified accounting experts take care of the rest: bookkeeping, VAT &Corporate Tax prep, financial reports, and all FTA filings on your behalf. No missed deadlines. No penalties — just more time to grow your business.",
	bookFreeConsultation: "Book Free Consultation",
	calculateMySavings: "Calculate My Savings",
	startingAt: "Starting at {{price}} AED/month",
	zeroAccountingKnowledgeNeeded: "Zero Accounting Knowledge needed",
	wePayAnyFinesIfWeMakeAnError:
		"100% COMPLIANT: We pay any fines if we make an error",
	officialPartnersOfUaeLeadingOrganizations:
		"Official Partners of UAE's Leading Organizations",
	whyChooseUs: "Why Choose Us?",
	whySmartUaeBusinessesChooseTheAccounter:
		"Why Smart UAE Businesses Choose The Accounter",
	moreThanJustAccountingYourCompleteComplianceAndFinancialPartner:
		"More than just accounting - your complete compliance and financial partner",
	seeYourExactSavings: "See your exact savings",
	howItWorks: "How it works?",
	howItWorksDesc: "Upload your invoices. We do the rest. It's that simple.",
	getStartedToday: "Get Started Today!",
	testimonials: "Testimonials",
	monthly: "Monthly",
	quarterly: "Quarterly",
	choosePlan: "Choose Plan",
	frequentlyAskedQuestions: "Frequently Asked Questions",
	everythingYouNeedToKnowAboutTheAccounter:
		"Everything you need to know about The Accounter",
	getStartedWithTheAccounterToday:
		"Get Started With <br /> The Accounter Today!",
	leaveMessage: "Leave a message",
	name: "Name",
	yourName: "Your name",
	email: "Email",
	yourEmail: "Your email",
	phoneNumber: "Phone Number",
	yourPhoneNumber: "Your phone number",
	companyName: "Company Name",
	message: "Message",
	enterMessage: "Enter a message",
	bookFreeCall: "Book Free Call",
	navHowItWorks: "How it works",
	company: "Company",
	learningHub: "Learning Hub",
	savingCalculator: "Saving Calculator",
	ourServices: "OUR SERVICES",
	servicesHeroTitle: "Everything handled, A to Z.",
	servicesHeroSubTitle:
		"One subscription. Your VAT, Corporate Tax, and bookkeeping fully manage by certified experts. You upload invoices. We handle the rest.",
	additionalServices: "ADDITIONAL SERVICES",
	additionalServicesHeadline: "Easy-to-Use Accounting Features",
	additionalServicesSubText:
		"We do your Accounting, So you do better Business.",
	fromPrice: "From {{price}} AED/month",
	noLongTermContract: "No long-term contracts",
	cancelAnytime: "Cancel anytime",
	ourPartners: "OUR PARTNERS",
	partnersHeroHeadline: "Official partners of UAE's leading organizations.",
	partnersHeroSubText:
		"We've partnered with the UAE's most trusted business ecosystems to give their members exclusive access to The Accounter at special rates.",
	whoWeWorkWith: "WHO WE WORK WITH",
	partnerRegisteration: "PARTNER REGISTRATION",
	sendRegistrationRequest: "Send a Registration Request",
	yourCompanyNameAsPerTradeLicense: "Your company name as per Trade License",
	partner: "Partner",
	selectAPartner: "Select a Partner",
	fileNumber: "File Number",
	with: "with",
	send: "Send",
	how_it_works: "HOW IT WORKS",
	uploadYourInvoices: "Upload your invoices.",
	weHandleEverythingElse: "We handle everything else.",
	howItWorksSubText:
		"No office visits. No accounting knowledge needed. Just upload and let our certified experts take care of the rest VAT, Corporate Tax, bookkeeping, and all FTA filings.",
	theProcess: "THE PROCESS",
	theProcessHeadline: "Three steps. Zero stress.",
	theProcessSubText:
		"From invoice upload to FTA submission everything is handled by our team. You stay focused on your business.",
	complianceGuaranteed: "100% COMPLIANCE GUARANTEED",
	everythingYouNeedToKnow: "Everything you need to know.",
	academy: "Academy",
	notPartnerMember: "Not a partner member?",
	notPartnerMemberSubText:
		"You can still get started with The Accounter. Book a free consultation and our team will walk you through the best plan for your business.",
	askQuestion: "Ask a question...",
	aboutTheAccounter: "About The Accounter",
	pageCannotBeFound: "Page cannot be found",
	letsGetBackToBusiness: "Let’s get back to business",
	goToHome: "Go to Home",
	contactAnExpert: "Contact an Expert",
	cancel: "Cancel",
	allPlansIncludeTheseFeatures: "All plans include these features",
	savingsCalculator: "SAVINGS CALCULATOR",
	calculateYourSavings: "Calculate Your Savings",
	AED: "AED",
	month: "Month",
	starter: "Starter",
	growth: "Growth",
	scale: "Scale",
	plan: "Plan",
	year: "year",
	yourCurrentAnnualCost: "Your current annual cost",
	withTheAccounter: "With The Accounter",
	VATPreparationFiling: "VAT Preparation & Filing",
	corporateTaxPreparationFiling: "Corporate Tax Preparation & Filing",
	monthlyFinancialReports: "Monthly Financial Reports",
	layerExpertValidation: "6-Layer Expert Validation",
	worth: "worth",
	plusYouGetFree: "PLUS you get FREE",
	totalFreeValue: "Total Free Value",
	getStartedFrom: "Get Started From {{price}} AED/month",
	overBusinessesUseTheAccounter:
		"Over <span>{{count}}</span> Businesses Use The Accounter",
	corporateTax: "Corporate Tax",
};

export default en;
